import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {OrganizationExperienceService} from "../../services/organization-experience.service";
import {MilestonesService} from "../../services/milestones.service";
import gsap from "gsap";
import {Milestone} from "../../interfaces/milestone";
import {AnimationItem} from "lottie-web";
import {StudentAuthService} from "../../services/student-auth.service";
import {DataService} from "../../services/data.service";

@Component({
  selector: 'brt-experience-progress',
  templateUrl: './experience-progress.component.html',
  styleUrls: ['./experience-progress.component.scss']
})
export class ExperienceProgressComponent implements OnInit, OnDestroy {

  // @ViewChildren('milestoneSequenceCanvas') set setMilestonesSequenceCanvas(elements: QueryList<ElementRef>) {
  //   if(elements.length) {
  //     elements.forEach(element => {
  //       const canvas = element.nativeElement as HTMLCanvasElement;
  //       canvas.setAttribute("width", canvas.parentElement?.clientWidth + "");
  //       canvas.setAttribute("height", canvas.parentElement?.clientHeight + "");
  //
  //       const ctx = canvas.getContext("2d");
  //
  //       const milestoneIdAttr = canvas.getAttribute("data-milestone-id");
  //       if(ctx && milestoneIdAttr) {
  //         const milestoneId = parseInt(milestoneIdAttr);
  //         const foundMilestone = this.milestonesService.getMilestones().filter((el) => el.id === milestoneId);
  //
  //         if(foundMilestone.length) {
  //           const milestoneData = foundMilestone[0];
  //
  //           const sequenceImages: HTMLImageElement[] = [];
  //           const totalSequenceLength = 12;
  //
  //           const promises: Promise<void>[] = [];
  //           for(let i = 1; i <= totalSequenceLength; i++) {
  //             const promise = new Promise<void>((resolve, reject) => {
  //               const image = new Image();
  //               sequenceImages.push(image);
  //               image.onload = () => {
  //                 resolve();
  //               };
  //
  //               let idxWidthLeadingZero = i.toString();
  //               if(idxWidthLeadingZero.length === 1) idxWidthLeadingZero = "0" + idxWidthLeadingZero;
  //               image.src = "/assets/game-dashboard-icons/milestones/sequence/" + milestoneData.sequenceFolder + "/" + milestoneData.sequenceFolder + "" + idxWidthLeadingZero + ".png";
  //             })
  //
  //             promises.push(promise);
  //           }
  //
  //           Promise.all(promises).then(() => {
  //             this.renderCanvasImageSequence(sequenceImages, ctx);
  //           })
  //
  //         }
  //
  //       }
  //     })
  //
  //     // TODO destroy on onDestroy
  //   }
  // }
  @ViewChild('mainEl') mainEl!: ElementRef;

  milestoneSequenceCanvas: QueryList<ElementRef> = new QueryList<ElementRef>();

  uiCurrentExperience: number = 0;

  currentExperience: number = 0;

  totalMilestones = 0;
  achievedMilestones = 0;
  isLastMilestoneAchieved = false;

  isInit = false;

  milestoneAnimations: AnimationItem[] = [];
  milestoneAnimationsTimeouts: number[] = [];
  private readonly MILESTONE_ANIMATION_RESTART_DELAY = 5000; // ms
  private readonly MILESTONE_ANIMATION_AFTER_CREATE_DELAY = 2000; // ms

  private readonly TRANSITION_SPEED = 100; // px/s
  private readonly TRANSITION_DURATION = 1.6; // sec
  private readonly TRANSITION_EASING = "Power4.easeOut";

  milestones = this.milestonesService.getMilestones();

  constructor(
    private experienceService: OrganizationExperienceService,
    private milestonesService: MilestonesService,
    private studentAuthService: StudentAuthService,
    private data: DataService
  ) {
  }

  async ngOnInit() {
    this.totalMilestones = this.milestonesService.getMilestones().length;

    const classData = this.studentAuthService.getClassData();
    this.data.getSchoolClassPoints(classData.classCode).subscribe((experience) => {

      // console.log("experience", experience);

      window.requestAnimationFrame(() => {
        this.setExperience(experience - 5000, true); // TODO uncomment it
        // this.setExperience(33500, true);
        // this.setExperience(0, true); // TODO comment it
        this.isInit = true;

        window.requestAnimationFrame(() => {
          this.setExperience(experience); // TODO uncomment it
        });
      });

      this.setExperience(experience); // TODO uncomment it

    });
  }

  setExperience(val: number, instant = false): void {
    if(val < 0) val = 0;
    if(val >  this.milestonesService.MAX_EXPERIENCE_VALUE) val = this.milestonesService.MAX_EXPERIENCE_VALUE;

    const mainEl = this.mainEl.nativeElement as HTMLElement;

    const milestoneEls = mainEl.querySelectorAll(".experience-progress__milestone");
    const scrollableRowEl = mainEl.querySelector(".experience-progress__progress-row");
    const progressFillEl = mainEl.querySelector(".experience-progress__progress-bar-common-fill");
    if(val > this.currentExperience) {
      let isLastMilestoneAchieved = false;

      let targetMilestoneIdx = -1;
      for(let i = 0; i < this.milestones.length; i++) {
        if(val < this.milestones[i].points) {
          targetMilestoneIdx = i;
          break;
        }
      }

      if(targetMilestoneIdx === -1) {
        targetMilestoneIdx = this.milestones.length;
        isLastMilestoneAchieved = true;
      }

      const totalDuration = targetMilestoneIdx * 0.2 + 0.6;
      let startCounter = {value: 0};


      const firstMilestoneEl = milestoneEls[0] as HTMLElement;
      const milestoneWidth = firstMilestoneEl.clientWidth;


      const currentMilestonePoints = isLastMilestoneAchieved ? this.milestonesService.MAX_EXPERIENCE_VALUE : this.milestones[targetMilestoneIdx].points;
      const previousMilestonePoints = targetMilestoneIdx === 0 ? 0 : this.milestones[targetMilestoneIdx - 1].points;
      const currentMilestoneProgressAbsolute = val - previousMilestonePoints;
      const currentMilestoneProgressRelative = currentMilestoneProgressAbsolute / (currentMilestonePoints - previousMilestonePoints);

      let targetScrollProgress = milestoneWidth * targetMilestoneIdx + currentMilestoneProgressRelative * milestoneWidth;

      // console.log(targetScrollProgress);

      const duration = instant ? 0 : this.TRANSITION_DURATION;

      gsap.to(scrollableRowEl, {
        duration: duration,
        translateX: -targetScrollProgress + "px",
        ease: this.TRANSITION_EASING,
        onComplete: () => {
        }
      });

      gsap.to(progressFillEl, {
        duration: duration,
        width: targetScrollProgress + "px",
        ease: this.TRANSITION_EASING,
        onComplete: () => {
          // resolve(null);
        }
      });

      gsap.fromTo(startCounter, {
        value: this.uiCurrentExperience,
      }, {
        value: val,
        duration: duration,
        ease: this.TRANSITION_EASING,
        onUpdate: () => {
          this.uiCurrentExperience = Math.round(startCounter.value);
        }
      });

      this.achievedMilestones = targetMilestoneIdx;
      this.isLastMilestoneAchieved = isLastMilestoneAchieved;
    }

    this.currentExperience = val;
  }

  getDuration(width: number): number {
    return width / this.TRANSITION_SPEED;
  }

  isMilestoneBlocked(milestone: Milestone): boolean {
    return milestone.points > this.currentExperience;
  }

  milestoneHasSequenceAnimation(milestone: Milestone): boolean {
    return milestone.hasAnimation;
  }

  addProgress() {
    this.setExperience(this.currentExperience + Math.floor(Math.random() * 2000));
  }

  renderCanvasImageSequence(images: HTMLImageElement[], ctx: CanvasRenderingContext2D, idx = 0, lastTime = 0) {
    if(idx > images.length - 1) idx = 0;
    window.requestAnimationFrame(() => {
      const newTime = Date.now();
      if(newTime > lastTime + 100) {
        ctx.clearRect(0, 0, ctx.canvas.clientWidth, ctx.canvas.clientHeight);
        ctx.drawImage(images[idx], 0, 0, ctx.canvas.clientWidth, ctx.canvas.clientHeight);
        this.renderCanvasImageSequence(images, ctx, idx + 1, newTime);
      } else {
        this.renderCanvasImageSequence(images, ctx, idx + 1, lastTime);
      }


    });
  }

  onMilestoneAnimCreated($event: AnimationItem) {
    const animation = $event;
    this.milestoneAnimations.push(animation);

    const that = this;
    animation.addEventListener("complete", function onAnimEnd() {
      animation.goToAndStop(0);

      const timeout = window.setTimeout(() => {
        that.playMilestoneAnim(animation);
        that.milestoneAnimationsTimeouts = that.milestoneAnimationsTimeouts.filter((el) => el !== timeout);
      }, that.MILESTONE_ANIMATION_RESTART_DELAY);
      that.milestoneAnimationsTimeouts.push(timeout);
    })

    setTimeout(() => {
      this.playMilestoneAnim($event);
    }, Math.floor(Math.random() * this.MILESTONE_ANIMATION_AFTER_CREATE_DELAY));
  }

  playMilestoneAnim(animation: AnimationItem) {
    animation.play();
  }

  ngOnDestroy() {
    this.milestoneAnimationsTimeouts.forEach((el) => {
      window.clearTimeout(el);
    });
  }


}
